var map = {
	"./01 Congratulations.gif": 8919,
	"./02 confetti .gif": 7253,
	"./2fverify.svg": 9737,
	"./ACCC.svg": 8060,
	"./Aadhaar-bg.png": 9858,
	"./Aadhaar-bg.svg": 3616,
	"./Ac.svg": 762,
	"./Acaddon.svg": 9176,
	"./Air Conditioner.svg": 5820,
	"./Approved.png": 8509,
	"./Avatar copy.png": 9800,
	"./Avatar.png": 9359,
	"./BROLINK.svg": 3645,
	"./BROSTICK.svg": 3343,
	"./CD LOGO.svg": 5792,
	"./CD-LOGO.svg": 2173,
	"./CD-finallogin.svg": 807,
	"./Cancelled.png": 9439,
	"./CholaLogo.svg": 6474,
	"./DL-bg.svg": 6402,
	"./DP creative.svg": 5345,
	"./Declined.png": 9334,
	"./Group.svg": 4495,
	"./HI.png": 909,
	"./Hold.png": 2427,
	"./Inprogress.png": 6696,
	"./LoginBg.svg": 3448,
	"./LoginObject.svg": 692,
	"./Not-Match.svg": 8893,
	"./PAN-bg.png": 7951,
	"./PAN-bg.svg": 6429,
	"./PDF_file_icon.svg": 2439,
	"./QR_CHOLA.png": 4237,
	"./Queue.png": 3691,
	"./Refrigerator.svg": 4692,
	"./SCAN.svg": 6869,
	"./TAP.svg": 2889,
	"./Voter.png": 7988,
	"./Voter.svg": 1548,
	"./aadhar-doc.svg": 3680,
	"./aadhar-file-icon.svg": 1002,
	"./ackologo.svg": 1397,
	"./ackopop.svg": 5333,
	"./addon_anmol.svg": 6114,
	"./addoncd.svg": 1633,
	"./addoncon.svg": 1104,
	"./afterselfie-img.png": 5570,
	"./ai_plus.png": 1147,
	"./amstrad.png": 3742,
	"./anmol.svg": 2217,
	"./anmol2.svg": 3097,
	"./anmollll.png": 8882,
	"./banktick.svg": 1731,
	"./barcode.svg": 7142,
	"./black_deker.png": 7487,
	"./calender-r.svg": 981,
	"./camera.svg": 3755,
	"./cancelup.svg": 8391,
	"./cd-cholalogo.svg": 4612,
	"./cd-login.svg": 383,
	"./cd-up.svg": 9183,
	"./chola-right.svg": 9250,
	"./chola_logo 1.svg": 4934,
	"./cholacd.svg": 5194,
	"./cholamandalam-logo.png": 1752,
	"./cholams.svg": 6823,
	"./cholaside.svg": 7982,
	"./cholawhite.svg": 806,
	"./circlele.svg": 5759,
	"./close-circle.svg": 2407,
	"./common-doc.svg": 3068,
	"./conf.gif": 5261,
	"./congrats.gif": 4916,
	"./consumerprod.svg": 7165,
	"./copy-link.svg": 6778,
	"./croooos.svg": 7428,
	"./cross-ex.svg": 8176,
	"./dd.svg": 7790,
	"./delete-icon.svg": 9515,
	"./delete.svg": 5863,
	"./deviceenroll.svg": 6472,
	"./dige.svg": 1839,
	"./digigi.svg": 8651,
	"./digilocker-img.svg": 8945,
	"./digiprod.svg": 7776,
	"./dl-icon.svg": 8816,
	"./edit.svg": 9338,
	"./editwifi.svg": 5065,
	"./eligibleotp.svg": 9388,
	"./eligimob.svg": 9888,
	"./emptydealer.svg": 1150,
	"./esignsample.svg": 9786,
	"./exclaim.svg": 1971,
	"./exist.svg": 551,
	"./eye.svg": 5297,
	"./faceselfie.svg": 2897,
	"./female_after.svg": 2457,
	"./female_before.svg": 4700,
	"./ffffr.svg": 9368,
	"./filed.svg": 2912,
	"./finallogin.svg": 7497,
	"./fridge-1.svg": 9903,
	"./fridge-2.svg": 876,
	"./fridge-3.svg": 8237,
	"./fridge-4.svg": 9714,
	"./fridge-5.svg": 3443,
	"./fridge-up.svg": 1049,
	"./fridge.svg": 7149,
	"./full quality  1.mp4": 9148,
	"./gender-icon.svg": 7485,
	"./geo-error.svg": 780,
	"./godrej.png": 2185,
	"./green.svg": 2143,
	"./green_bg.svg": 2643,
	"./haier.png": 285,
	"./haier.svg": 4345,
	"./hdfc.svg": 379,
	"./hhhhhh.svg": 3326,
	"./hi.svg": 9839,
	"./homeapp.svg": 8292,
	"./hp.png": 7836,
	"./i-icon.svg": 8191,
	"./ico-DigiL.svg": 8389,
	"./ico-share.svg": 9187,
	"./ico-success.svg": 4943,
	"./ico-tick-bg.svg": 7491,
	"./ico-uidai.svg": 9834,
	"./ifb.png": 2423,
	"./ifbrl.png": 1005,
	"./image 133.png": 1370,
	"./indkal.png": 1117,
	"./infinix.png": 3625,
	"./inprogress-ex.svg": 8532,
	"./invoiceimg.svg": 5560,
	"./iqoo.png": 2327,
	"./laptoppp.svg": 2102,
	"./lastttick.svg": 3681,
	"./lb.svg": 2904,
	"./lb_bg.svg": 5314,
	"./lg.svg": 3925,
	"./llyod.png": 7110,
	"./login_bg_1.mp4": 338,
	"./login_bg_2.mp4": 3237,
	"./mail-icon.svg": 5951,
	"./maintence.svg": 5934,
	"./male_after.svg": 670,
	"./male_before.svg": 4065,
	"./mandatesuccess.svg": 9751,
	"./map.svg": 8908,
	"./mob.svg": 3964,
	"./mobile-auth.svg": 7343,
	"./mobileotp.svg": 2311,
	"./mobilephn.png": 8442,
	"./new-coin.gif": 3463,
	"./new-congratulations.gif": 3721,
	"./niva_bupa.svg": 6919,
	"./no-benef.svg": 6282,
	"./no-image.svg": 2251,
	"./no2.svg": 7907,
	"./nothing.png": 6717,
	"./noti.svg": 1278,
	"./oneaslogo.svg": 3427,
	"./oneplus.png": 8818,
	"./oppo.png": 4242,
	"./oppo.svg": 1776,
	"./orange.svg": 4076,
	"./orange_bg.svg": 8238,
	"./pan-doc.svg": 1622,
	"./passport-doc.svg": 6197,
	"./passworddd.svg": 4461,
	"./pdf.svg": 9392,
	"./pdf2.svg": 8690,
	"./peach.svg": 9801,
	"./peach_bg.svg": 8133,
	"./perrel.png": 5426,
	"./phoneadon.svg": 9454,
	"./phonnne.svg": 9878,
	"./pink.svg": 4018,
	"./pink_bg.svg": 7748,
	"./pp-back.svg": 1206,
	"./pp-front.svg": 9984,
	"./preview-doc.pdf": 103,
	"./profilepop.svg": 5998,
	"./purple.svg": 1656,
	"./purple_bg.svg": 1330,
	"./qr.svg": 5835,
	"./qrcode.svg": 9848,
	"./radio-sel.svg": 3300,
	"./realme.png": 4910,
	"./redmi.png": 6785,
	"./reject.svg": 6899,
	"./rejected.gif": 9021,
	"./rupee.gif": 6510,
	"./scan-icon.svg": 617,
	"./sel-tick.svg": 1604,
	"./selfie-icon.svg": 7308,
	"./selfie-img.svg": 6712,
	"./selfie.svg": 18,
	"./send-sms.png": 8294,
	"./serial.png": 1184,
	"./serial.svg": 5810,
	"./shortcut-icon.png": 1081,
	"./store.png": 4497,
	"./store.svg": 1873,
	"./summaryfridge.svg": 9017,
	"./takeselfie.png": 9053,
	"./tcl.png": 2343,
	"./tecno.png": 3979,
	"./television.svg": 7062,
	"./thumb-card.svg": 3381,
	"./thumb-pan.svg": 7492,
	"./thumbpro.svg": 7763,
	"./tick-check.svg": 4810,
	"./tick-ex.svg": 873,
	"./tick-icon.svg": 1353,
	"./tickcon2.svg": 2335,
	"./tickimage.svg": 3852,
	"./updatedbg.svg": 682,
	"./upload-poi.svg": 9486,
	"./uu.svg": 3440,
	"./vector.svg": 8259,
	"./vivo.png": 1822,
	"./voltas.png": 3353,
	"./voltas_Beko.png": 6815,
	"./voterid-doc.svg": 1574,
	"./vzy.png": 6139,
	"./walton.png": 3915,
	"./warning.svg": 6426,
	"./wash.svg": 3267,
	"./washing-adon.svg": 1922,
	"./washingmech.svg": 678,
	"./wave.svg": 1169,
	"./whatsapp-icon.png": 5274,
	"./whirlpool.png": 1764,
	"./whirlpool.svg": 4008,
	"./wifi.svg": 797,
	"./wifi2.svg": 7333,
	"./wm.svg": 8050,
	"./wobble.png": 8683,
	"./wrongimg.svg": 2394,
	"./xiaomi.png": 4239,
	"./yourfile.pdf": 3525,
	"./yy.svg": 1864
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;